import { fetchTrades } from '@/api/trades';

export async function fetch({ commit, state }) {
   if (state.loaded) {
      return Promise.resolve();
   }
   return fetchTrades()
      .then(trades => {
         commit('setTrades', trades);
         commit('setLoaded', true);
      });
}
